import { Controller } from "@hotwired/stimulus"

import Stimulus from "../../shared/utils/stimulus"

// savings

class HomePageSavings extends Controller {
  static targets = [`pie`, `chart`]

  connect() {
    document.documentElement.addEventListener(
      `turbo:frame-render`,
      this.turboFrameRender
    )
  }
}

Stimulus.register(`home-page-savings`, HomePageSavings)
